import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

// Bluesky account info lives in auth_db.bluesky_account table for now
// until the dedicated backend is created
export const http = createDashHttpClient(env.authUrl);

export async function getBlueskyAccount(
  { brandId }: { brandId: number | string },
  config: HttpRequestConfig = {},
) {
  return http.get(`/api/brands/${brandId}/bluesky/handle`, config);
}

export async function getBlueskyAccountAllBrands(
  { brandIds }: { brandIds: number[] },
  config: HttpRequestConfig = {},
) {
  return http.put(`/api/brands/bluesky/handle`, { brand_ids: brandIds }, config);
}
